import * as Config from '../config';
import React, { useCallback, useEffect} from 'react';
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { setModal, setAuth, setAuthResponse, setUser, setStoreAuth, setForceLog, setSubscription } from "../actions/index";
import './library/onboarding/Log.css'

import Welcome from './library/custom/-APP_TARGET/mods/modal/Welcome';
// import SignIn from './library/signin/Modal';
// import Registration from './library/registration/Modal';
import LinkModal from './library/custom/-APP_TARGET/content/LinkModal';
import LinkPro from './library/custom/-APP_TARGET/content//LinkPro';

import ModalCTA from './library/modal/ModalCTA';
import ModalButton from './library/modal/ModalButton';

/* Store Auth Management */
function ConnectedLogWrapper({
  setAuth, setAuthResponse, setUser, setModal, setStoreAuth,
  isConnected, isForceLog, setForceLog
}) {
  let globalHistory = useHistory();

  // Custom Modal Link Subscription
  const link = useCallback((underlayClickExits = true) => {
    setModal({
      content: <LinkModal />,
      underlayClickExits
    })
  }, [setModal]);

  // Custom Modal Link Pro Subscription
  const linkPro = useCallback(() => {
    setModal({
      content: <LinkPro />,
      underlayClickExits: true
    })
  }, [setModal]);

  const registration = useCallback((underlayClickExits = true) => {
    // V1 - DEPRECATED
    // setModal({
    //   content: <Registration />,
    //   underlayClickExits
    // })
    const clientID = Config.API_CLIENT_ID; //v2
    const uri = `${window.location.origin}/new-account`;
    // const uri = (window.location.origin.includes('localhost')) ? `${window.location.origin}/` : `${window.location.origin}/home`;
    window.open(`${Config.API_IDENTITY_URL}/register?response_type=code&client_id=${clientID}&redirect_uri=${uri}`, `_self`);
  }, [/*setModal*/]);

  const signupPM = useCallback(() => {
    const showRegistration = () => {
      setTimeout(() => { registration() }, 500);
    }
    setModal({
      content: (
        <ModalCTA
          title={'Join the party'}
          description={'Create your free Beatport account to send requests, chat, and save playlists.'}
          styleContainer={{marginTop: `-60%`, marginLeft: `-5%`}}
          styleBody={{ gap: 16 }}
          styleDescription={{ marginBottom: 16 }}
          classModal={`bottom-reduce`}
        >
        <ModalButton label={`Sign up`} onClick={showRegistration} />
        <ModalButton label={`Close`} className={`cancel`} />
        </ModalCTA>
      )
    });
  }, [setModal, registration]);

  // V1
  // const signin = useCallback((underlayClickExits = true) => setModal({
  //   content: <SignIn />,
  //   underlayClickExits
  // }), [setModal]);
  const signin = useCallback(() => {
    const clientID = Config.API_CLIENT_ID; //v2
    const uri = (window.location.origin.includes('localhost')) ? `${window.location.origin}/` : `${window.location.origin}/home`;
    window.open(`${Config.API_IDENTITY_URL}/o/authorize/?response_type=code&client_id=${clientID}&redirect_uri=${uri}`, `_self`); 
  }, []);


  // V2 - Custom Modal Welcome DJ APP
  const welcome = useCallback((underlayClickExits = null) => {
    const isNew = !localStorage.getItem('fl');
    if (isNew && Config.ONBOARDING) {
      setModal({
        content: <Welcome />,
        underlayClickExits: (underlayClickExits === null) ? Config.FREEMIUM : underlayClickExits
      })
    } else {
      signin();
    }
  }, [setModal, signin]);

  const logout = useCallback(() => {
    if (isConnected) {
      localStorage.removeItem('expired');
      localStorage.removeItem('cQfdJ@gD8yjHqr'); // USERID
      sessionStorage.clear();
      setAuth({ token: null });
      setAuthResponse(null);
      setUser(null);
      setSubscription(false);

      // Logout Identity Service V2
      const uri = `${window.location.origin}/home`;
      window.location.href = `${Config.API_IDENTITY_URL}/identity/v1/logout/?callbackUrl=${uri}/`;
      // It feels chuncky - TODO - Need a GET success request to be smooth

      if (globalHistory.location.pathname.includes(`playlists`)) {
        globalHistory.push('/home');
      }
    }
  }, [globalHistory, setAuth, setAuthResponse, setUser, isConnected]);

  // Freemium Management
  useEffect(() => {
    if (isForceLog) {
      if (!localStorage.getItem('fl')) { //First Time
        if (!window.location.pathname.includes(`pm/`)) { globalHistory.push('/home'); } // Exception for Party Mode
        if (!Config.FREEMIUM) {
          welcome();
          if (!(!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime))) {
            const bigmsg = document.getElementById(`bigmsg`);
            if (bigmsg) {
              bigmsg.style.width = `500px`;
              bigmsg.style.left = `-20px`;
            }
          }
        }
      } else {
        if (!Config.FREEMIUM) {
          welcome();
          setForceLog(false);
        }
      }
    }

  }, [isForceLog, welcome, setForceLog, globalHistory])

  useEffect(() => {
    setStoreAuth({ signin, logout, welcome, link, linkPro, registration, signupPM })
  }, [setStoreAuth, signin, logout, welcome, link, linkPro, registration, signupPM])

  return null;
}

const LogWrapper = connect(
  state => ({
    isConnected: state.isConnected,
    isForceLog: state.isForceLog
  }),
  dispatch => ({
    setModal: content => dispatch(setModal(content)),
    setAuth: (form) => dispatch(setAuth(form)),
    setUser: data => dispatch(setUser(data)),
    setAuthResponse: state => dispatch(setAuthResponse(state)),
    setStoreAuth: store => dispatch(setStoreAuth(store)),
    setForceLog: state => dispatch(setForceLog(state)),
    setSubscription: state => dispatch(setSubscription(state))
  })
)(ConnectedLogWrapper);

export default LogWrapper;
